import './about-person.component.scss'

import 'swiper/css'

import Swiper from 'swiper'

class PersonBlogs {
  constructor(elements) {
    this.elements = elements

    this.init()
  }

  defineSlider() {
    new Swiper(this.elements.slider, {
      spaceBetween: 24,
      slidesPerView: 1,
      breakpoints: {
        480: {
          slidesPerView: 1.5
        },
        667: {
          slidesPerView: 1.8
        },
        768: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: 1.2
        }
      }
    })
  }

  init() {
    this.defineSlider()
  }
}

const aboutPersonEl = document.querySelector('.about-person')
if (aboutPersonEl) {
  const slider = aboutPersonEl.querySelector('.person-blogs__slider')
  new PersonBlogs({
    slider
  })
}


// person info
const personInfo = document.querySelector('.person-info')
const parentPersonInfo = document.querySelector('.about-person__col_media')
const personSlider = document.querySelector('.about-person__slider')

const mediaQuery = window.matchMedia('(max-width: 1023px)')

function handleMediaChange(e) {
  if (e.matches) {
		personSlider.parentNode.insertBefore(personInfo, personSlider)
  } else {
		parentPersonInfo.appendChild(personInfo)
  }
}

if (personInfo && parentPersonInfo && personSlider) {
	mediaQuery.addEventListener('change', handleMediaChange)
	handleMediaChange(mediaQuery)
}
